import { BaseService } from "./base.service";
export class CmsService extends BaseService {
  static async getCms() {
    try {
      const response = await this.request().get(
        `${process.env.VUE_APP_API_GET_CMS_PATH}/collections/get/pages?token=${process.env.VUE_APP_API_CMS_TOKEN}`
      );
      return response.data;
    } catch (e) {
      console.log("e", e.message);
      throw new Error(e.message);
    }
  }
}
